import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IKPIVistoriaEntregaDeChavesProps {
    DT_SLA: string;
    DT_SLO?: string;
}

export default function KPIVistoriaEntregaDeChaves(
    props: IKPIVistoriaEntregaDeChavesProps
) {
    const dateSLA = new Date(props.DT_SLA);
    const dateHoje = new Date();
    const colorSLA =
        dateSLA.getDate() === dateHoje.getDate() &&
        dateSLA.getMonth() === dateHoje.getMonth() &&
        dateSLA.getFullYear() === dateHoje.getFullYear()
            ? "warning"
            : dateHoje < dateSLA
            ? "success"
            : "danger";

    const colorSLO =
        props.DT_SLO &&
        new Date(props.DT_SLO) < dateHoje
            ? "danger"
            : "success";

    return (
        <div className="d-flex align-items-center flex-wrap w-100">
            {props.DT_SLA && (
                <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                    <span className="mr-4">
                        <FontAwesomeIcon
                            icon={faCircle}
                            className={`icon-2x text-${colorSLA} font-weight-bold`}
                        />
                    </span>
                    <div className="d-flex flex-column text-dark-75">
                        <span className="font-size-sm">SLA</span>
                        <span className="font-weight-bolder">
                            {new Date(props.DT_SLA).toLocaleString()}
                        </span>
                    </div>
                    {props.DT_SLO && (
                        <div className="d-flex align-items-center flex-lg-fill mr-2 my-1" style={{ marginLeft: "20px" }}>
                            <span className="mr-4">
                                <FontAwesomeIcon
                                    icon={faCircle}
                                    className={`icon-2x text-${colorSLO} font-weight-bold`}
                            />
                            </span>
                            <div className="d-flex flex-column text-dark-75">
                                <span className="font-size-sm">SLO</span>
                                <span className="font-weight-bolder">
                                    {new Date(props.DT_SLO).toLocaleString()}
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
